var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "24 10 24 24",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D32F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.62 23.824L34.188 15.4H36.852L36.402 23.824H34.62ZM35.52 28.126C35.1 28.126 34.752 27.988 34.476 27.712C34.2 27.436 34.062 27.106 34.062 26.722C34.062 26.338 34.2 26.014 34.476 25.75C34.752 25.474 35.1 25.336 35.52 25.336C35.94 25.336 36.282 25.474 36.546 25.75C36.81 26.014 36.942 26.338 36.942 26.722C36.942 27.106 36.81 27.436 36.546 27.712C36.282 27.988 35.94 28.126 35.52 28.126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ba430aa851ae902c01fbeafd7e43741c.svg";
export { ForwardRef as ReactComponent };